// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class ServicesService {

  apiUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;
  }

  getAllServices(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `services`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  getServicesByMobilityId(
    id: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `mobility/${id}/services`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  getServicesCatalogueByMobilityId(
    id: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `mobility/${id}/services/catalogue/grouped`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  editServicesCatalogueByMobilityId(
    id: string = '',
    servicesGroups: any
  ): Observable<any> {
    const body = JSON.stringify(servicesGroups);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `mobility/${id}/services/catalogue/grouped`;

    return this.http.put(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  createServiceByMobilityId(
    id: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `mobility/${id}/services`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  updateServiceByServiceToEmployeeId(
    mobilityId: string = '',
    serviceToEmployeeId: number,
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `mobility/${mobilityId}/services/serviceToEmployee/${serviceToEmployeeId}`;

    return this.http.put(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  attachEYMPService(
    serviceToEmployeeId: string,
    pathwayRef: string
  ): Observable<{success: boolean, message?: string}> {
    const body = JSON.stringify({ pathwayRef });
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `service-to-employee/${serviceToEmployeeId}/attach-eymp-service`;

    return this.http.patch<{success: boolean, message?: string}>(requesttUrl, body, { headers })
      .pipe(
        map((res) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }}